import JwtService from "./jwtService";
import axios from "@axios";

export default new JwtService(axios, {});
